import { toCurrencyTruncated } from '@/utilities/formatting';
import { format } from 'date-fns';
import { usePriceHistoryData } from '@components/MiniPriceChart';
import { CURRENT_PERIOD } from '../constants';
import { cn } from '@simplywallst/ui-core/next';

interface Props {
  time: number | null;
  sharePrice: number | null;
  currencyISO?: string;
  companyId: string;
}

export const SharePrice = ({
  time,
  sharePrice,
  currencyISO,
  companyId,
}: Props) => {
  const { data, isNegativeMovement } = usePriceHistoryData(
    companyId,
    CURRENT_PERIOD
  );

  const lastSharePrice = data.entities[data.keys[data.keys.length - 1]];
  const price = sharePrice ?? lastSharePrice;

  const formattedPrice = price
    ? toCurrencyTruncated(price || 0, 2, currencyISO ?? 'XXX')
    : 'n/a';

  const formattedTime = time ? format(time, 'MMM dd yyyy') : `n/a`;
  const formattedLabel = sharePrice === null ? 'Share Price' : formattedTime;

  return (
    <div className="grid grid-cols-[auto_1fr] gap-2">
      <div
        className={cn(
          'mt-[5px] size-1.5 rounded-full',
          isNegativeMovement ? 'bg-bad' : 'bg-good'
        )}
      />
      <div className="grid gap-1">
        <div className="text-tiny font-medium text-soft">{formattedLabel}</div>
        <div className="truncate whitespace-nowrap text-xs text-solid">
          {formattedPrice}
        </div>
      </div>
    </div>
  );
};
